import isNil from 'lodash/isNil';
import {
  isEmptyString,
} from '@populateui/utils';
import dayjs, {
  Dayjs,
} from 'utils/dayjs';
import {
  formatDate,
} from 'utils/date';

type ToDoDueDateValue = Dayjs | string | Date | null | undefined;

export type ToDoDueDateState = 'default' | 'upcoming' | 'overdue';

function parseToDoDueDate(value: ToDoDueDateValue) {
  if (isNil(value) || (typeof value === 'string' && isEmptyString(value))) {
    return null;
  }

  const dueDate = dayjs(value);

  return dueDate.isValid() ? dueDate : null;
}

function getRelativeDayOffset(dueDate: Dayjs) {
  return dueDate.startOf('day').diff(dayjs().startOf('day'), 'day');
}

export function getToDoDueDateLabel(value: ToDoDueDateValue) {
  const dueDate = parseToDoDueDate(value);

  if (!dueDate) {
    return '';
  }

  const relativeDayOffset = getRelativeDayOffset(dueDate);

  if (relativeDayOffset === 0) {
    return 'Today';
  }

  if (relativeDayOffset === 1) {
    return 'Tomorrow';
  }

  if (relativeDayOffset === -1) {
    return 'Yesterday';
  }

  if (relativeDayOffset < -1) {
    const absoluteOffset = Math.abs(relativeDayOffset);
    return `${absoluteOffset} day${absoluteOffset === 1 ? '' : 's'} ago`;
  }

  if (relativeDayOffset > 1) {
    return `In ${relativeDayOffset} day${relativeDayOffset === 1 ? '' : 's'}`;
  }

  return formatDate(dueDate);
}

export function getToDoDueDateState(value: ToDoDueDateValue): ToDoDueDateState {
  const dueDate = parseToDoDueDate(value);

  if (!dueDate) {
    return 'default';
  }

  const relativeDayOffset = getRelativeDayOffset(dueDate);

  if (relativeDayOffset < 0) {
    return 'overdue';
  }

  if (relativeDayOffset <= 1) {
    return 'upcoming';
  }

  return 'default';
}
